// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('stock.scannerinventorying.inventory.articledetails', {
        url: '/article/{articleId}/location/{locationId}/variantdetail/{variantDetailId}',
        templateUrl: 'main/stock/scannerinventorying/inventory/articledetails/articledetails.tpl.html',
        controller: 'ArticleDetailsController as vm',
        resolve: {
            stockTransactions: stockTransactionsResolver,
            article: articleResolver
        }

    });
}

// @ngInject
function stockTransactionsResolver($stateParams, StockApiService) {
    return StockApiService.getStockTransactionsForArticleAndLocation(
        {
            articleId: $stateParams.articleId,
            locationId: $stateParams.locationId,
            variantDetailId: $stateParams.variantDetailId
        }
        );
}

// @ngInject
function articleResolver($stateParams, StockApiService) {
    return StockApiService.getProduct($stateParams.articleId);
}

// @ngInject
function ArticleDetailsController(stockTransactions, article) {
    var vm = this;

    var transactionsGrid = {};
    var rowData = [];
    var rowCollection = new wijmo.collections.CollectionView(rowData);

    vm.stockTransactions = stockTransactions;
    vm.currentVariantDetail1 = {};
    vm.article = article;

    vm.initGrid = initGrid;

    activate();

    function activate() {
        if (vm.stockTransactions.length !== 0) {
            vm.currentVariantDetail1 = vm.stockTransactions[0].articleVariant.variantDetail1;
        }
    }

    function initGrid(sender) {
        transactionsGrid = sender;

        transactionsGrid.initialize({
            autoGenerateColumns: false,
            selectionMode: wijmo.grid.SelectionMode.Row,
            allowDragging: wijmo.grid.AllowDragging.None,
            allowResizing: wijmo.grid.AllowResizing.None,
            itemsSource: rowCollection
        });

        updateTransactionGridGroupings();

        transactionsGrid.collapseGroupsToLevel(0);

        setUpGridData();
        loadGridData();

        transactionsGrid.collapseGroupsToLevel(0);
    }

    function updateTransactionGridGroupings() {
        transactionsGrid.groupHeaderFormat = '{value}';

        var timeTypeGrouping = new wijmo.collections.PropertyGroupDescription('', function(item, prop) {
            return item.accountingDate.toString().split(" ")[0] + " " + item.transactionType;
        });

        transactionsGrid.collectionView.groupDescriptions.push(timeTypeGrouping);

        transactionsGrid.invalidate();
        transactionsGrid.collectionView.refresh();
    }

    function setUpGridData() {

        var rowHeader = new wijmo.grid.Column();
        rowHeader.binding = "accountingDate";
        rowHeader.header = " ";
        rowHeader.allowSorting = false;
        rowHeader.width = 150;
        rowHeader.isReadOnly = true;
        transactionsGrid.columns.push(rowHeader);

        rowHeader = new wijmo.grid.Column();
        rowHeader.binding = "transactionType";
        rowHeader.header = " ";
        rowHeader.allowSorting = false;
        rowHeader.width = 150;
        rowHeader.isReadOnly = true;
        transactionsGrid.columns.push(rowHeader);

        var columns = getDataColumns();

        // Add dynamic columns
        _.forEach(columns, function(variantDetail) {
            var c = new wijmo.grid.Column();
            c.binding = variantDetail.variantDetailName;
            c.header = variantDetail.variantDetailName;
            c.width = "*";
            c.allowSorting = false;
            c.inputType = 'text';
            c.isReadOnly = true;
            c.align = 'Right';
            c.aggregate = 'Sum';
            transactionsGrid.columns.push(c);
        });
    }

    function getDataColumns() {
        var columns = [];
        var articleVariants = [];

        _.forEach(vm.stockTransactions, function(stockTransaction) {
            articleVariants.push(stockTransaction.articleVariant);
        });

        // Group by nested variantDetail2 in the current articleVariants
        columns = _.groupBy(articleVariants, function(variant) {
            return variant.variantDetail2.variantDetailName;
        });
        // Get the variantDetail2 from each group in an array
        columns = _.reduce(columns, function(newArray, val, key) {
            newArray.push(val[0].variantDetail2);
            return newArray;
        }, []);

        return _.sortBy(columns, 'sortOrder');
    }

    function loadGridData() {
        var variantRows = _.groupBy(vm.stockTransactions, function(stockTransaction) {
            return stockTransaction.articleVariant.variantDetail1.id;
        });

        var stockTransactions = _.sortBy(vm.stockTransactions, 'accountingDate');

        _.forEach(stockTransactions, function (stockTransaction) {
            var r = {};

            r.transactionDate = stockTransaction.transactionDate.toString().replace('T', ' ');
            r.accountingDate = stockTransaction.accountingDate.toString().replace('T', ' ');
            r.transactionType = stockTransaction.stockTransactionType.stockTransactionTypeName;
            r[stockTransaction.articleVariant.variantDetail2.variantDetailName] = stockTransaction.quantity;

            rowData.push(r);
        });

        rowCollection.refresh();
    }
}

angular
    .module('scannerinventorying.inventory.articledetails', [])
    .config(stateConfig)
    .controller('ArticleDetailsController', ArticleDetailsController);
